// eslint-disable-next-line import/prefer-default-export
export const SET_MOS_EMAIL_SETTINGS = 'SET_MOS_EMAIL_SETTINGS';

export const SET_CHAIN_DATA = 'SET_CHAIN_DATA';
export const SET_OFFER_DATA = 'SET_OFFER_DATA';
export const RESET_OFFER_DATA = 'RESET_OFFER_DATA';
